import { callGlobalFunction, readGlobal } from "./utils.js";

export const providerFeature = {
  get session() {
    return readGlobal("currentProvider", null);
  },
  showDashboard() {
    return callGlobalFunction("showProviderDashboard");
  },
  refreshOrders() {
    return callGlobalFunction("renderProviderOrders");
  },
  refreshReviews() {
    return callGlobalFunction("renderProviderReviews");
  }
};
